<div *ngIf="showDiscount" class="product-price-before-discount">
    De:
    <span class="price">
        {{ listPrice | currency:'BRL' }}
    </span>
    <span class="percentage">
        {{percentageDifference | percent:'1.2-2':'pt_BR'}}
    </span>
</div>